/**
 * External research bench seed and the upload form's vocabularies.
 *
 * THE SEED IS DELIBERATELY EMPTY. The bench now lists documents that were
 * genuinely uploaded and stored (see `src/data/documents`), so seeding it with
 * invented third-party reports would put rows on screen that have no file
 * behind them — which is precisely the 2.1 behaviour this replaces.
 *
 * RESEARCH_VOCABULARY stays and is still classified INTERNAL. It is the
 * controlled vocabulary the upload form and the filter chips both read, so they
 * cannot drift: in 2.0 they were separate lists, and you could upload a
 * category no chip would ever show.
 */

import type { ExternalReport, ResearchVocabulary } from '../../contracts';

export const SEED_EXTERNAL: readonly ExternalReport[] = [];

export const RESEARCH_VOCABULARY: ResearchVocabulary = {
  sources: [
    'Nielsen',
    'YouGov',
    'Relo Metrics',
    'Deloitte',
    'WARC',
    'IEG',
    'Kantar',
    'Ipsos',
    'PwC',
    'EY',
    'KPMG',
    'Forrester',
    'Gartner',
    'McKinsey',
    'Custom Research',
    // The client is a first-class source: a partner recap or a brand's own
    // extract is evidence like any vendor's, and the Data Confidence Score
    // judges it on the same scorecard. Choosing it asks which side of the
    // relationship it came from, because that changes how the figure reads.
    'Client',
    'Other',
  ],
  categories: [
    'Media Impact',
    'Media Impact Forecast',
    'Brand Equity',
    'Brand Tracking',
    'Benchmarking',
    'Industry Research',
    'Industry Analysis',
    'Market Research',
    'Market Intelligence',
    'Research',
    'Social Media',
    'Financial Analysis',
    'Consumer Insights',
    'Competitive Intelligence',
    'Partnership Valuation',
    'Mid-season report',
    'End-season report',
  ],
  brands: [
    'Aviva',
    'Allianz',
    'AXA',
    'Zurich Insurance',
    'Munich Re',
    'Swiss Re',
    'Generali',
    'Prudential',
    'MetLife',
    'AIG',
    'Adidas',
    'Shimano',
    'Wien Energie',
    'Puma',
  ],
  partners: [
    'UEFA',
    "UEFA Women's Football",
    'FIFA',
    'IOC',
    'Manchester United',
    'Real Madrid',
    'FC Barcelona',
    'FC Bayern Munich',
    'SK Rapid Wien',
    'McLaren Racing',
    'Mercedes F1',
    'Premier League',
    'NFL',
    'NBA',
  ],
  teams: [
    'Partnerships',
    'Marketing',
    'Finance',
    'Strategy',
    'Legal',
    'Data & Analytics',
    'Commercial',
    'Brand',
  ],
};
